import { fetcher } from '../../utils/fetch.js';

export default class ProductVideosApp {
	constructor() {
		this.product_videos_init = false;
		this.bindEvents();
	}

	bindEvents () {
		document.addEventListener('[product-video]:load-preview', function(event) {
			var video = event.detail;

			if (!video.classList.contains('thumb-loaded')) {
				this.getThumb(video);
			}
		}.bind(this));
	}

	getThumb (video) {
		var thumb = video.querySelector('img');
		var videoUrl = video.getAttribute('data-url');
		var youtube_id = this.getYoutubeId(videoUrl);
		var vimeo_id = this.getVimeoId(videoUrl);

		video.classList.add('progress');
		thumb.classList.remove('lazy');

		if (vimeo_id) {
			this.getVimeoThumbUrl(vimeo_id)
				.then(function(response) {
					if (response) {
						const response_json = JSON.parse(response);
						if (response_json[0].thumbnail_large) {
							thumb.setAttribute('src', response_json[0].thumbnail_large);
						} else {
							thumb.setAttribute('src', thumb.getAttribute('data-src'));
						}
					}
					video.classList.remove('progress');
					video.classList.add('thumb-loaded');
					this.setEmbed(video);
				}.bind(this));
		} else {
			if (youtube_id) {
				thumb.setAttribute('src', this.getYoutubeThumbUrl(youtube_id));
			} else {
				thumb.setAttribute('src', thumb.getAttribute('data-src'));
			}
			this.setEmbed(video);
			video.classList.remove('progress');
			video.classList.add('thumb-loaded');
		}
	}

	getYoutubeId (url) {
		var re = /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\/?\?(?:\S*?&?v\=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/g;
		return ( url.match( re ) ) ? RegExp.$1 : false;
	}

	getVimeoId  (url) {
		var re = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i;
		return ( url.match( re ) ) ? RegExp.$1 : false;
	}

	getYoutubeThumbUrl (video_id) {
		return '//img.youtube.com/vi/' + video_id + '/hqdefault.jpg';
	}

	getVimeoThumbUrl (video_id) {
		return fetcher('//vimeo.com/api/v2/video/' + video_id + '.json', {
			is_text: true
		});
	}

	setEmbed (video) {
		video.addEventListener('click', function() {
			var iframe = document.createElement('iframe');
			iframe.classList.add('embed-responsive-item');
			iframe.setAttribute('frameborder', '0');
			iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
			iframe.setAttribute('allowfullscreen', '');
			iframe.setAttribute('src', video.getAttribute('data-url') + '?rel=0&showinfo=0&autoplay=1');
			video.innerHTML = '';
			video.appendChild(iframe);
			video.classList.add('embed-responsive-4by3');
			video.classList.add('video-embed');
		}, {
			once: video.classList.contains('video')
		});
	}
}
